import { useParams } from "react-router-dom";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { LeadDashboardProvider } from "./components/lead-dashboard/LeadDashboard.provider";
import { LeadDashboard } from "./components/lead-dashboard";

function LeadDetailsPage() {
  const { leadId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <LeadDashboardProvider leadId={leadId || ''}>
          <LeadDashboard />
        </LeadDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default LeadDetailsPage